import React, {Component} from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';
import { print } from '../managers/Logger'

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
  }

  async getToken(data) {
    print("fetching token")
      let {token} = await this.props.stripe.createToken({name: data.name, address_country: 'US'});
      print(token)
      return token
  }

  render() {
    return (
      <div className="checkout">
        <CardElement className="stripe-checkout"/>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);